import React, { FC } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import LinearProgress from '@mui/material/LinearProgress';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { useTranslate } from 'src/shared/providers';

interface Props {
  isEmpty: boolean;
  isUpdating?: boolean;
  skeletonRows?: number;
  skeletonHeight?: number;
}

export const DataGridLoadingOverlay: FC<Props> = ({ isEmpty, isUpdating, skeletonRows = 20, skeletonHeight = 36 }) => {
  const { t } = useTranslate();

  if (isEmpty) {
    return (
      <Stack direction="column">
        {Array.from(Array(skeletonRows).keys()).map((index) => (
          <Skeleton key={`pending-request-loader-${index}`} height={skeletonHeight} sx={{ mx: 2 }} />
        ))}
      </Stack>
    );
  }

  if (isUpdating) {
    return (
      <Stack
        direction="column"
        justifyContent="center"
        alignItems="center"
        gap={1}
        sx={(theme) => ({
          height: '100%',
          zIndex: 1,
          position: 'relative',
          backgroundColor: theme.palette.action.disabledBackground,
        })}
      >
        <CircularProgress />
        <Typography variant="h5">{t('global.loading')}</Typography>
      </Stack>
    );
  }

  return <LinearProgress sx={{ zIndex: 1 }} />;
};
